import { AttendanceMenuController } from './AttendanceMenuController';
import * as angular from 'angular';
import 'angular-ui-router';
import 'angular-scalyr';
import permissions from 'application/detail/permissions.json';
import AttendanceMenuView from './AttendanceMenuView.html';
import desk from './desk';
import ConfigurationView from './configuration/ConfigurationView.html';
import { ConfigurationController } from './configuration/ConfigurationController';
import TeamView from './team/TeamView.html';
import { TeamController } from './team/TeamController';
import AttendantPermissionView from './team/AttendantPermission/AttendantPermissionView.html';
import { AttendantPermissionController } from './team/AttendantPermission/AttendantPermissionController';
import { AttendantPermissionService } from 'modules/application/detail/attendance/team/AttendantPermission/AttendantPermissionService';
import { channels } from './configuration/channels';
import { TeamService } from 'modules/application/detail/attendance/team/TeamService';
import { AttendantItemComponent } from './team/AttendantItem';
import DashboardAttendanceView from './dashboard/DashboardAttendanceView.html';
import { DashboardAttendanceController } from './dashboard/DashboardAttendanceController';
import { DashboardService } from 'modules/application/detail/attendance/dashboard/DashboardService';
import { DashboardRealTimeMonitoringService } from 'modules/application/detail/attendance/dashboard/DashboardRealTimeMonitoringService';
import { BotClientService } from './dashboard/BotClientService';
import ReportView from './report/ReportView.html';
import DataExtractorView from './dataExtractor/DataExtractorView.html';
import { DataExtractorReportController } from './dataExtractor/DataExtractorReportController';
import { ReportController } from './report/ReportController';
import { ReportService } from './report/ReportService';
import RulesView from './rules/RulesView.html';
import { RulesController } from './rules/RulesController';
import { NewRuleItemComponent } from './rules/rulesNew/RuleItem';
import { RulesService } from 'modules/application/detail/attendance/rules/services/RulesService';
import { ConditionLoadValues } from 'modules/application/detail/attendance/condition/ConditionLoadValues';
import { ConditionItemNewComponent } from './condition';
import { PaginationComponent } from './pagination';
import { WidgetHelpCenterComponent } from './widgetHelpCenter';
import { FilterAutocompleteWithDropdownComponent } from './filterAutocompleteWithDropdown';
import { FilterWithDropdownComponent } from './filterWithDropdown';
import { FilterWithDropdownChipsComponent } from './filterWithDropdownChips';
import { PriorityLoadValues } from './priorityRules/PriorityLoadValues';
import { RuleContainerComponent } from './queueManagement/QueuePage/RuleContainer';
import { PriorityContainerComponent } from './queueManagement/QueuePage/PriorityContainer';
import { TagsContainerComponent } from './queueManagement/QueuePage/TagsContainer';
import { TagsQueueService } from './queueManagement/QueuePage/TagsContainer/services/TagsQueueService';
import { PriorityRuleItemComponent } from './priorityRules/priorityRuleItem';
import { PriorityRulesService } from 'modules/application/detail/attendance/priorityRules/services/PriorityRulesService';
import QueuesView from './queueManagement/QueuesView.html';
import { QueuesController } from './queueManagement/QueuesController';
import { QueuesService } from './queueManagement/services/QueuesService';
import { QueuePageController } from './queueManagement/QueuePage/QueuePageController';
import QueuePageView from './queueManagement/QueuePage/QueuePageView.html';
import { QueueItemComponent } from './queueManagement/QueueItem';
import { AttendanceHourService } from './attendanceHour/AttendanceHourService';
import HistoryView from './history/HistoryView.html';
import { HistoryController } from './history/HistoryController';
import { HistoryService } from 'modules/application/detail/attendance/history/HistoryService';
//Old Custom Replies - BLiP Desk
import RepliesView from './replies/RepliesView.html';
import { RepliesController } from './replies/RepliesController';
import { RepliesService } from './replies/RepliesService';
import { CategoryItemComponent } from './replies/CategoryItem';
import ReplyView from './reply/ReplyView.html';
import { ReplyController } from './reply/ReplyController';
//New Custom Replies - BLiP Desk
import CategoriesView from './replies2/CategoriesView.html';
import { CategoriesController } from './replies2/CategoriesController';
import { RepliesService2 } from './replies2/RepliesService2';
import { CategoryItemComponent2 } from './replies2/categoryItem';
import CategoryView from './replies2/categoryPage/CategoryView.html';
import { CategoryController } from './replies2/categoryPage/CategoryController';
import UserDetailView from '../users/detail/UserDetailView.html';
import { UserDetailController } from 'modules/application/detail/users/detail/UserDetailController';
import { AttendanceFeatures } from './AttendanceFeatures';
import { UnavailableToolWarningComponent } from './unavailableWarning/unavailableToolWarning.component';
import { DeskConfigurationService } from './DeskConfigurationService';
import ActiveMessageView from './activemessage/ActiveMessageView.html';
import { ActiveMessageDeskController } from './activemessage/ActiveMessageDeskController';
import { TicketLinkService } from 'modules/application/detail/users/detail/ticketLinkModal/TicketLinkService';
/* Micro frontend imports */
import DeskView from './DeskView.html';
import { DeskController } from './DeskController';
import { RealtimeSidebarService } from './RealTimeSidebarService';
import { AttendantsContainerComponent } from './queueManagement/QueuePage/AttendantsContainer';
import { QueueItemBuilderComponent } from './queueManagement/QueueItemBuilder';
export const attendanceStateName = 'auth.application.detail.attendance';
export const deskMicrofrontStateName = 'auth.application.detail.helpdesk';
export default angular
    .module('attendance', ['ui.router', 'shared', 'sly', channels, desk])
    .service('TeamService', TeamService)
    .service('AttendantPermissionService', AttendantPermissionService)
    .service('RepliesService', RepliesService)
    .service('RepliesService2', RepliesService2)
    .service('HistoryService', HistoryService)
    .service('DashboardService', DashboardService)
    .service('DashboardRealTimeMonitoringService', DashboardRealTimeMonitoringService)
    .service('RulesService', RulesService)
    .service('QueuesService', QueuesService)
    .service('AttendanceHourService', AttendanceHourService)
    .service('PriorityRulesService', PriorityRulesService)
    .service('TagsQueueService', TagsQueueService)
    .service('ReportService', ReportService)
    .service('BotClientService', BotClientService)
    .service('DeskConfigurationService', DeskConfigurationService)
    .service('RealtimeSidebarService', RealtimeSidebarService)
    .service('LoadValues', ConditionLoadValues)
    .service('PriorityLoadValues', PriorityLoadValues)
    .service('TicketLinkService', TicketLinkService)
    .component('attendantItem', AttendantItemComponent)
    .component('ruleContainer', RuleContainerComponent)
    .component('priorityContainer', PriorityContainerComponent)
    .component('tagsContainer', TagsContainerComponent)
    .component('attendantsContainer', AttendantsContainerComponent)
    .component('queueItem', QueueItemComponent)
    .component('queueItemBuilder', QueueItemBuilderComponent)
    .component('newRuleItem', NewRuleItemComponent)
    .component('priorityRuleItem', PriorityRuleItemComponent)
    .component('categoryItem', CategoryItemComponent)
    .component('categoryItem2', CategoryItemComponent2)
    .component('conditionItemNew', ConditionItemNewComponent)
    .component('paginationWithLabel', PaginationComponent)
    .component('widgetHelpCenter', WidgetHelpCenterComponent)
    .component('filterWithDropdown', FilterWithDropdownComponent)
    .component('filterAutocompleteWithDropdown', FilterAutocompleteWithDropdownComponent)
    .component('filterWithDropdownChips', FilterWithDropdownChipsComponent)
    .component('unavailableToolWarning', UnavailableToolWarningComponent)
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state(deskMicrofrontStateName, {
            url: '/helpdesk/{path:any}',
            reloadOnSearch: false,
            views: {
                'content@auth.application.detail': {
                    template: DeskView,
                    controller: DeskController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                hasOwnFooter: true,
            },
        })
            .state(attendanceStateName, {
            url: '/attendance',
            redirectTo: 'auth.application.detail.attendance.channels',
            data: {
                permissionClaim: permissions.desk.claim,
            },
            resolve: {
                // It's necessary to keep the 'application' dependency here, so the resolve waits for the application to be loaded (FeatureToggleClientService.initializeApplication).
                isUseDeskMicroFrontendEnabled: ['application', async function (application) { return AttendanceFeatures.isUseDeskMicroFrontendEnabled(); }],
                isAttendanceMenuMfeEnabled: ['application', function (application) { return AttendanceFeatures.isAttendanceMenuMfeEnabled(); }],
            },
            views: {
                'sidenav@auth.application.detail': {
                    templateProvider: (isAttendanceMenuMfeEnabled) => {
                        'ngInject';
                        return isAttendanceMenuMfeEnabled ? '' : AttendanceMenuView;
                    },
                    controllerProvider: (isAttendanceMenuMfeEnabled) => {
                        'ngInject';
                        return isAttendanceMenuMfeEnabled ? null : AttendanceMenuController;
                    },
                    controllerAs: '$ctrl',
                },
            },
            onEnter: ['$state', 'isUseDeskMicroFrontendEnabled', function ($state, isUseDeskMicroFrontendEnabled) {
                    if (isUseDeskMicroFrontendEnabled) {
                        $state.go(deskMicrofrontStateName, undefined, { notify: false });
                        return;
                    }
                }],
            params: { area: 'desk' },
        })
            .state('auth.application.detail.attendance.channels', {
            url: '/channels',
            views: {
                'content@auth.application.detail': {
                    template: ConfigurationView,
                    controller: ConfigurationController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.desk.claim,
            },
            params: { area: 'desk' },
        })
            .state('auth.application.detail.attendance.report', {
            url: '/report',
            views: {
                'content@auth.application.detail': {
                    template: ReportView,
                    controller: ReportController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.desk.claim,
            },
            params: { area: 'desk' },
        })
            .state('auth.application.detail.attendance.report.data-extractor', {
            url: '/data-extractor',
            views: {
                'content@auth.application.detail': {
                    template: DataExtractorView,
                    controller: DataExtractorReportController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.desk.claim,
            },
            params: { area: 'desk' },
        })
            .state('auth.application.detail.attendance.dashboard', {
            url: '/dashboard?team?attendant?customer',
            reloadOnSearch: false,
            views: {
                'content@auth.application.detail': {
                    template: DashboardAttendanceView,
                    controller: DashboardAttendanceController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.desk.claim,
            },
            params: { area: 'desk' },
        })
            .state('auth.application.detail.attendance.team', {
            url: '/team',
            views: {
                'content@auth.application.detail': {
                    template: TeamView,
                    controller: TeamController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.desk.claim,
            },
            params: { area: 'desk' },
        })
            .state('auth.application.detail.attendance.team.permission', {
            url: '/permission',
            views: {
                'content@auth.application.detail': {
                    templateProvider: () => {
                        'ngInject';
                        return AttendantPermissionView;
                    },
                    controllerProvider: () => {
                        'ngInject';
                        return AttendantPermissionController;
                    },
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.desk.claim,
            },
            params: { area: 'desk' },
        })
            .state('auth.application.detail.attendance.history', {
            url: '/history?customer?operator?team?tag?start?end?sequentialId?offset',
            reloadOnSearch: false,
            views: {
                'content@auth.application.detail': {
                    template: HistoryView,
                    controller: HistoryController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.desk.claim,
            },
            params: { area: 'desk' },
        })
            .state('auth.application.detail.attendance.history.detail', {
            url: '/:id?ticketId',
            views: {
                'content@auth.application.detail': {
                    template: UserDetailView,
                    controller: UserDetailController,
                    controllerAs: '$ctrl',
                },
                'sidenav@auth.application.detail': {},
            },
            params: { area: 'desk' },
        })
            .state('auth.application.detail.attendance.rules', {
            url: '/rules',
            views: {
                'content@auth.application.detail': {
                    templateProvider: () => {
                        'ngInject';
                        return RulesView;
                    },
                    controllerProvider: () => {
                        'ngInject';
                        return RulesController;
                    },
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.desk.claim,
            },
            params: { area: 'desk' },
        })
            .state('auth.application.detail.attendance.queueManagement', {
            url: '/queueManagement',
            views: {
                'content@auth.application.detail': {
                    templateProvider: () => {
                        'ngInject';
                        return QueuesView;
                    },
                    controllerProvider: () => {
                        'ngInject';
                        return QueuesController;
                    },
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.desk.claim,
            },
            params: { area: 'desk' },
        })
            .state('auth.application.detail.attendance.queueManagement.queue', {
            url: '/queue/:id',
            views: {
                'content@auth.application.detail': {
                    templateProvider: () => {
                        'ngInject';
                        return QueuePageView;
                    },
                    controllerProvider: () => {
                        'ngInject';
                        return QueuePageController;
                    },
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.desk.claim,
            },
            params: { area: 'desk' },
        })
            .state('auth.application.detail.attendance.replies', {
            url: '/replies',
            resolve: {
                isDeskNewCustomRepliesEnabled: ['$q', 'application', function ($q, application) {
                        const deferred = $q.defer();
                        deferred.resolve(AttendanceFeatures.isDeskNewCustomRepliesEnabled());
                        return deferred.promise;
                    }],
            },
            views: {
                'content@auth.application.detail': {
                    templateProvider: (isDeskNewCustomRepliesEnabled) => {
                        'ngInject';
                        return isDeskNewCustomRepliesEnabled ? CategoriesView : RepliesView;
                    },
                    controllerProvider: (isDeskNewCustomRepliesEnabled) => {
                        'ngInject';
                        return isDeskNewCustomRepliesEnabled ? CategoriesController : RepliesController;
                    },
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.desk.claim,
            },
            params: { area: 'desk' },
        })
            .state('auth.application.detail.attendance.replies.reply', {
            url: '/category/:id',
            resolve: {
                isDeskNewCustomRepliesEnabled: ['$q', 'application', function ($q, application) {
                        const deferred = $q.defer();
                        deferred.resolve(AttendanceFeatures.isDeskNewCustomRepliesEnabled());
                        return deferred.promise;
                    }],
            },
            views: {
                'content@auth.application.detail': {
                    templateProvider: (isDeskNewCustomRepliesEnabled) => {
                        'ngInject';
                        return isDeskNewCustomRepliesEnabled ? CategoryView : ReplyView;
                    },
                    controllerProvider: (isDeskNewCustomRepliesEnabled) => {
                        'ngInject';
                        return isDeskNewCustomRepliesEnabled ? CategoryController : ReplyController;
                    },
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.desk.claim,
            },
            params: { area: 'desk' },
        })
            .state('auth.application.detail.attendance.activemessage', {
            url: '/activemessage',
            views: {
                'content@auth.application.detail': {
                    templateProvider: () => {
                        'ngInject';
                        return ActiveMessageView;
                    },
                    controllerProvider: () => {
                        'ngInject';
                        return ActiveMessageDeskController;
                    },
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.desk.claim,
            },
            params: { area: 'desk' },
        });
    }]).name;
